import { ComponentClass } from 'react';

import InputBase from './Base';
import { CoreFormElementSearch } from '../../../components/';

/**
 * Search Input Controller
 * @export
 * @class SearchInputController
 * @extends {InputBase}
 */
export default class SearchInputController extends InputBase {
  /**
   * Controlled Element
   * @override
   * @static
   * @memberof SearchInputController
   */
  public static ControlledElement: ComponentClass<any> = CoreFormElementSearch;
}
